define(function (require, exports, module) {
    'use strict';

    const { sendXray, sendKaktamLog } = require('reactApp/utils/ga');

    /**
     * @namespace
     */
    var uploadRadar = {
        /**
         * @type {string}
         */
        groupName: 'app_new-upload',

        /**
         * На grepmaillog файл будет иметь имя cloud_NewUpload.log
         * @type {string}
         */
        kaktamName: 'NewUpload',

        /**
         * @type {RegExp}
         */
        counterNamePattern: /^[a-z][a-z0-9-_]{3,}$/,

        /**
         * @param {string} counterName
         * @param {number} [counterValue]
         * @returns {Radar.Deferred}
         */
        sendCounter: function (counterName, counterValue = 0) {
            var pattern = uploadRadar.counterNamePattern;

            if (!pattern.test(counterName)) {
                throw new TypeError('The counter name does not match the pattern: ' + pattern);
            }

            if (counterValue == undefined) {
                counterValue = 1; // prevent time sent
            } else if (parseInt(counterValue, 10) != counterValue) {
                throw new TypeError('The counter value may only be an integer or undefined');
            }

            sendXray([uploadRadar.groupName, counterName, counterValue]);
        },

        /**
         * @param {Object} data
         * @returns {Radar.Deferred}
         */
        sendLog: function (data) {
            if (Object(data) !== data) {
                throw new TypeError('The data may only be an Object');
            }

            sendKaktamLog(uploadRadar.kaktamName, data);
        },

        /**
         * @returns {Radar}
         */
        create: function () {
            return RADAR.group(uploadRadar.groupName);
        },
    };

    module.exports = uploadRadar;
});
